import type {SsoLink} from '@/state/ducks/externalLinks';
import type {RootState} from '@/state/store';

const EMPTY_SSO_LINK: SsoLink = {};

export const selectSsoLink =
    (template: string | null | undefined) =>
    (state: RootState): SsoLink => {
        if (!template) return EMPTY_SSO_LINK;
        return state.externalLinks.ssoLinks[template] ?? EMPTY_SSO_LINK;
    };
